const duration = (minute) => {
    if(!minute > 0) return '';
    
    const h = Math.floor(minute / 60);
    const m = Math.round(minute % 60);
    return h > 0 ? `${h} hr ${m} min` : `${m} min`;
};

export default duration;